




































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class HdrTangniaobing extends Vue {
  @Prop()
  private message: any;
  private current: any = {
  };
  private changeCurrentItem(item) {
    this.$set(this, "current", item);
  }
  private mounted() {
    if (this.message && this.message.length > 0) {
      this.current = this.message[0];
    }
  }
}
